import React from 'react';
import './style.css';


const Banner = () => {
  return (
    <div className="containerImgNosotros">
      <div className="contenedor-titulo">
        <h1><span>Refrigo</span></h1>
        <div className="contenedor-titulo-descripcion">
          Venta de equipos de Climatización
      </div>
      </div>
    </div>
  )
}

export default Banner;